import { isBeautifulLinkBasedOnId } from './beautifiedPrefix';

export default function isReadonlyBeautifulLink(node: Node): boolean {
    if (node instanceof HTMLAnchorElement) {
        const anchorElement = node as HTMLAnchorElement;
        if (isBeautifulLinkBasedOnId(anchorElement)) {
            const contentEditableValue: string = anchorElement.getAttribute('contenteditable');
            return !!contentEditableValue && contentEditableValue.toLowerCase() === 'false';
        }
    }

    return false;
}
